export const CHANGE_BPT_SCOPE_AXA_EVOLUTION = '/pages/brandPreferenceTracker/CHANGE_BPT_SCOPE_AXA_EVOLUTION';
export const CHECKED_EVOLUTION_BRANDS = '/pages/brandPreferenceTracker/CHECKED_EVOLUTION_BRANDS';

export const changeBPTScopeAxaEvolution = value => ({
    type: CHANGE_BPT_SCOPE_AXA_EVOLUTION,
    payload: value,
});

export const checkedEvolutionBrands = value => ({
    type: CHECKED_EVOLUTION_BRANDS,
    payload: value,
});
